module.exports = __webpack_public_path__ + "static/img/LuxTagTest.c191cc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/LuxTagTest.png
// module id = 0n1s
// module chunks = 15